import React from "react";

function Blogs() {
  return (
    <section className="px-6 py-16 text-center">
      <h2 className="text-4xl font-bold mb-10">MY <span className="text-yellow-500">BLOGS</span></h2>
      <p className="text-gray-400 mb-8">
      Coming soon! Stay tuned for my latest blogs and articles on web/mobile development, design, UI, BE and more.
      </p>
      {/* <div className="grid md:grid-cols-3 gap-6">
        {[
          "How to Own Your Audience by Creating an Email List",
          "Top 10 Toolkits for Deep Learning in 2020",
          "Everything You Need to Know About Web Accessibility",
          "How to Inject Humor & Comedy Into Your Brand",
          "Women in Web Design: How To Achieve Success",
          "Evergreen vs Topical Content: An Overview",
        ].map((title, i) => (
          <div key={i} className="bg-gray-800 p-4">
            <h3 className="font-bold mb-2">{title}</h3>
            <p className="text-gray-400 text-sm">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </p>
          </div>
        ))}
      </div> */}
    </section>
  );
}

export default Blogs;
